import React, { useState } from 'react';
const Navigation = ({ currentView, setCurrentView, isDarkMode, isAdminAuthenticated }) => {
  return (
    <nav className={`border-b transition-colors duration-200 px-4 z-[100] relative ${
      isDarkMode 
        ? 'bg-gray-800 border-gray-700' 
        : 'bg-white border-gray-200'
    }`}>
      <div className="max-w-6xl mx-auto">
        <div className="flex space-x-4 md:space-x-8 overflow-x-auto">
          <button
            onClick={() => setCurrentView("translator")}
            className={`py-3 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
              currentView === "translator"
                ? "border-blue-500 text-blue-600"
                : `border-transparent ${
                    isDarkMode 
                      ? 'text-gray-300 hover:text-white hover:border-gray-500' 
                      : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
            }`}
          >
            🔄 Translator
          </button>
          <button
            onClick={() => setCurrentView("membership")}
            className={`py-3 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
              currentView === "membership"
                ? "border-blue-500 text-blue-600"
                : `border-transparent ${
                    isDarkMode 
                      ? 'text-gray-300 hover:text-white hover:border-gray-500' 
                      : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
            }`}
          >
            ⭐ Membership
          </button>
          <button
            onClick={() => setCurrentView("profile")}
            className={`py-3 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
              currentView === "profile"
                ? "border-blue-500 text-blue-600"
                : `border-transparent ${
                    isDarkMode 
                      ? 'text-gray-300 hover:text-white hover:border-gray-500' 
                      : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
            }`}
          >
            👤 Profile
          </button>
          <button
            onClick={() => setCurrentView("admin")}
            className={`py-3 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${
              currentView === "admin"
                ? "border-blue-500 text-blue-600"
                : `border-transparent ${
                    isDarkMode 
                      ? 'text-gray-300 hover:text-white hover:border-gray-500' 
                      : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
            }`}
          >
            ⚙️ Admin {isAdminAuthenticated ? '✓' : '🔒'}
          </button>
        </div>
      </div>
    </nav>
  );
};


export default Navigation;
